import React from 'react';
import ArchitectureLayout from 'components/architecture/ArchitectureLayout';

/**
 * Resources API Endpoint Documentation
 */
const Resources = () => {
  const sections = [
    {
      id: 'overview',
      title: 'Resources API',
      content: `The Resources API provides operations for managing resources such as bots, knowledge bases, and other platform resources.

**Base Path**: \`/v1/resources\`

**Authentication**: Required (JWT token)

**Rate Limiting**: 100 requests per minute per tenant`
    },
    {
      id: 'endpoints',
      title: 'Available Endpoints',
      content: `### List or Create Resources
**Path**: \`/v1/resources\`
**Methods**: \`GET\`, \`POST\`

**GET**: List all resources accessible to the authenticated user
- Query parameters:
  - \`scope\`: \`tenant\` (default) or \`user\`
- Returns: Array of resource objects

**POST**: Create a new resource
- Request body: Resource creation payload
- Returns: Created resource object

### Get, Update, or Delete Resource
**Path**: \`/v1/resources/{resource_id}\`
**Methods**: \`GET\`, \`PUT\`, \`DELETE\`

**GET**: Retrieve a specific resource by ID
- Path parameter: \`resource_id\`
- Returns: Resource object

**PUT**: Update an existing resource
- Path parameter: \`resource_id\`
- Request body: Resource update payload
- Returns: Updated resource object

**DELETE**: Delete a resource
- Path parameter: \`resource_id\`
- Returns: Deletion confirmation

### Resource Configuration
**Path**: \`/v1/resources/{resource_id}/config\`
**Methods**: \`GET\`, \`POST\`, \`PATCH\`

Manage resource-specific configuration including CORS settings, API keys, and other configuration options.`
    },
    {
      id: 'examples',
      title: 'Example Requests',
      content: `### List Resources
\`\`\`bash
curl -X GET "https://api.example.com/api/v1/resources?scope=tenant" \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN"
\`\`\`

### Create Resource
\`\`\`bash
curl -X POST "https://api.example.com/api/v1/resources" \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{
    "name": "My Bot",
    "type": "bot",
    "config": {
      "description": "A helpful assistant"
    }
  }'
\`\`\``
    },
    {
      id: 'api-docs',
      title: 'Interactive Documentation',
      content: `For interactive API documentation with try-it-out functionality, visit:

[Resources API in API Documentation →](/api-docs#/customer-portal/resources)

You can test all endpoints, view request/response schemas, and see authentication requirements.`
    }
  ];

  return (
    <ArchitectureLayout
      title="Resources API"
      lastUpdated="2025-01-15"
      sections={sections}
    />
  );
};

export default Resources;

